module.exports = __webpack_public_path__ + "ef4be122809f5f675d3ac84d0f310fac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/barn-house-empty.png
// module id = 313
// module chunks = 0